import React, { Dispatch, useState } from 'react';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import Undefind from '../../assets/images/undefindResult.png';

import GreyPoint from '../../assets/images/GreyPoint.png';

import classes from './searchResult.module.scss';
import { Search } from '../../types/search';
import { PreLoader } from '../PreLoader';

type handleProps = {
  id: number;
  type: string;
};

type logsInfo = {
  id?: number;
  type?: number;
};
type SearchParams = {
  staff: {
    page: number;
    isTrue: boolean;
  };
  org: {
    page: number;
    isTrue: boolean;
  };
  sub: {
    page: number;
    isTrue: boolean;
  };
};

type Props = {
  searchResult: Search;
  searchString: string;
  searchLoading: boolean;
  handleSearchClick(): void;
  getSearchStaffTree(id: number): Promise<void>;
  getSearchSubTree(id: number): Promise<void>;
  getSearchOrgTree(id: number): Promise<void>;
  handleSetStaff({ type, id }: logsInfo): void;
  setEmployeeInfoShow: Dispatch<boolean>;
  setOrgInfoShow: Dispatch<boolean>;
  handleOrganizationInfo({ id, type }: handleProps): void;
  clearSearchResult(): void;
  setSearchParams: Dispatch<SearchParams>;
  searchParams: SearchParams;
};

const useStyles = makeStyles({
  show: {
    background: 'white',
    width: 160,
    height: 38,
    fontSize: 14,
    fontFamily: 'HelveticaNeueCyr',
    color: '#FF7221',
    border: '1px solid #FF7221',
    borderRadius: 0,
    // marginTop: 25,
    textTransform: 'none',
  },
});

export const SearchResult = ({
  searchResult,
  searchString,
  searchLoading,
  handleSearchClick,
  getSearchOrgTree,
  getSearchStaffTree,
  getSearchSubTree,
  handleSetStaff,
  setEmployeeInfoShow,
  setOrgInfoShow,
  handleOrganizationInfo,
  clearSearchResult,
  setSearchParams,
  searchParams,
}: Props) => {
  const style = useStyles();

  return (
    <>
      {searchLoading ? (
        <PreLoader />
      ) : !searchResult.data.subdivisions.subdivisions?.length &&
        !searchResult.data.staffs.staffs?.length &&
        !searchResult.data.organizations.organizations?.length ? (
        <div className={classes.image}>
          <img src={Undefind} alt="" />
        </div>
      ) : (
        <>
          {searchResult.data.staffs.staffs?.length ? (
            <>
              <div className={classes.result}>
                Найдено сотрудников ({searchResult.data.staffs.totalCount})
              </div>
              <div className={classes.table}>
                {searchResult.data.staffs.staffs.map((staff) => {
                  const stringArray = searchString.split(' ');

                  return (
                    <div
                      className={classes.table__row}
                      onClick={() => {
                        const response = getSearchStaffTree(staff.id);
                        response.then(() => {
                          handleSearchClick();
                          handleSetStaff({ id: staff.id, type: 3 });
                          setOrgInfoShow(false);
                          setEmployeeInfoShow(true);
                          clearSearchResult();
                        });
                      }}
                    >
                      <div className={classes.table__row__line__point}>
                        <img src={GreyPoint} alt="" />
                      </div>
                      <p className={classes.table__row__line__p}>
                        {staff.subdivisionSearch.subDivisionName} &nbsp;- &nbsp;
                      </p>
                      <p className={classes.table__row__line__p}>
                        {' '}
                        {staff.org.orgShortName} &nbsp;- &nbsp;
                      </p>
                      <p className={classes.table__row__line__p}>
                        {stringArray.find((el) =>
                          staff.lastname
                            .toLowerCase()
                            .includes(el.toLowerCase()),
                        ) ? (
                          <span style={{ color: '#FF7221' }}>
                            {staff.lastname}
                          </span>
                        ) : (
                          <span>{staff.lastname}</span>
                        )}{' '}
                        &nbsp;
                        {stringArray.find((el) =>
                          staff.firstname
                            .toLowerCase()
                            .includes(el.toLowerCase()),
                        ) ? (
                          <span style={{ color: '#FF7221' }}>
                            {staff.firstname}
                          </span>
                        ) : (
                          <span>{staff.firstname}</span>
                        )}{' '}
                        &nbsp;
                        {stringArray.find((el) =>
                          staff.middlename
                            .toLowerCase()
                            .includes(el.toLowerCase()),
                        ) ? (
                          <span style={{ color: '#FF7221' }}>
                            {staff.middlename}
                          </span>
                        ) : (
                          <span>{staff.middlename}</span>
                        )}{' '}
                        &nbsp;
                      </p>
                    </div>
                  );
                })}
              </div>

              {searchParams.staff.page !==
                searchResult.data.staffs.totalPages &&
              searchResult.data.staffs.totalPages ? (
                <div className={classes.button}>
                  <Button
                    className={style.show}
                    onClick={() => {
                      setSearchParams({
                        staff: {
                          page: searchParams.staff.page + 1,
                          isTrue: true,
                        },
                        org: {
                          page: searchParams.org.page,
                          isTrue: false,
                        },
                        sub: {
                          page: searchParams.sub.page,
                          isTrue: false,
                        },
                      });
                    }}
                  >
                    Загрузить еще
                  </Button>
                </div>
              ) : null}
            </>
          ) : null}

          {searchResult.data.subdivisions.subdivisions?.length ? (
            <>
              <div className={classes.result}>
                Найдено подразделений (
                {searchResult.data.subdivisions.totalCount})
              </div>
              <div className={classes.table}>
                {searchResult.data.subdivisions.subdivisions.map((sub) => {
                  const stringArray = searchString.split(' ');

                  return (
                    <div
                      className={classes.table__row}
                      onClick={() => {
                        const response = getSearchSubTree(sub.id);
                        response.then(() => {
                          handleSearchClick();
                          handleOrganizationInfo({
                            type: 'Подразделение',
                            id: sub.id,
                          });
                          handleSetStaff({ id: sub.id, type: 2 });
                          setOrgInfoShow(true);
                          setEmployeeInfoShow(false);
                          clearSearchResult();
                        });
                      }}
                    >
                      <div className={classes.table__row__line__point}>
                        <img src={GreyPoint} alt="" />
                      </div>
                      <p className={classes.table__row__line__p}>
                        {stringArray.find((el) =>
                          sub.subDivisionName
                            .toLowerCase()
                            .includes(el.toLowerCase()),
                        ) ? (
                          <span style={{ color: '#FF7221' }}>
                            {sub.subDivisionName}
                          </span>
                        ) : (
                          <span>{sub.subDivisionName}</span>
                        )}{' '}
                        &nbsp;- &nbsp;
                      </p>
                      <p className={classes.table__row__line__p}>
                        {' '}
                        {sub.organizationSearch.orgShortName}
                      </p>
                    </div>
                  );
                })}
              </div>
              {searchParams.sub.page !==
                searchResult.data.subdivisions.totalPages &&
              searchResult.data.subdivisions.totalPages ? (
                <div className={classes.button}>
                  <Button
                    className={style.show}
                    onClick={() => {
                      setSearchParams({
                        staff: {
                          page: searchParams.staff.page,
                          isTrue: false,
                        },
                        org: {
                          page: searchParams.org.page,
                          isTrue: false,
                        },
                        sub: {
                          page: searchParams.sub.page + 1,
                          isTrue: true,
                        },
                      });
                    }}
                  >
                    Загрузить еще
                  </Button>
                </div>
              ) : null}
            </>
          ) : null}

          {searchResult.data.organizations.organizations?.length ? (
            <>
              <div className={classes.result}>
                Найдено организаций (
                {searchResult.data.organizations.totalCount})
              </div>
              <div className={classes.table}>
                {searchResult.data.organizations.organizations.map((org) => {
                  const stringArray = searchString.split(' ');

                  return (
                    <div
                      className={classes.table__row}
                      onClick={() => {
                        const response = getSearchOrgTree(org.id);
                        response.then(() => {
                          handleSearchClick();
                          handleOrganizationInfo({
                            type: 'Организация',
                            id: org.id,
                          });
                          handleSetStaff({ id: org.id, type: 1 });
                          setOrgInfoShow(true);
                          setEmployeeInfoShow(false);
                          clearSearchResult();
                        });
                      }}
                    >
                      <div className={classes.table__row__line__point}>
                        <img src={GreyPoint} alt="" />
                      </div>
                      <p className={classes.table__row__line__p}>
                        {stringArray.find((el) =>
                          org.orgName.toLowerCase().includes(el.toLowerCase()),
                        ) ? (
                          <span style={{ color: '#FF7221' }}>
                            {org.orgName}
                          </span>
                        ) : (
                          <span>{org.orgName}</span>
                        )}{' '}
                      </p>
                    </div>
                  );
                })}
              </div>
              {searchParams.org.page !==
                searchResult.data.organizations.totalPages &&
              searchResult.data.organizations.totalPages ? (
                <div className={classes.button}>
                  <Button
                    className={style.show}
                    onClick={() => {
                      setSearchParams({
                        staff: {
                          page: searchParams.staff.page,
                          isTrue: false,
                        },
                        org: {
                          page: searchParams.org.page + 1,
                          isTrue: true,
                        },
                        sub: {
                          page: searchParams.sub.page,
                          isTrue: false,
                        },
                      });
                    }}
                  >
                    Загрузить еще
                  </Button>
                </div>
              ) : null}
            </>
          ) : null}
        </>
      )}
    </>
  );
};
